import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
    root: {
        width: '100%'
    }
});

export default useSx;
